import { COUNTRY_CODES } from "@/pages/VendorOnboarding/fields/PhoneField";

export const DEFAULT_COUNTRY_CODE = "+91";
export const POC_COUNTRY_CODE_FIELD = "poc_contact_country_code";

const CODES_LONGEST_FIRST = [...COUNTRY_CODES]
  .map((c) => c.code as string)
  .sort((a, b) => b.length - a.length);

export function splitPhone(
  raw: string | null | undefined,
  storedCode?: string | null,
): { countryCode: string; number: string } {
  const value = (raw ?? "").trim();
  const stored = (storedCode ?? "").trim();
  if (stored) return { countryCode: stored, number: value.replace(/\D/g, "") };
  const match = CODES_LONGEST_FIRST.find((code) => value.startsWith(code));
  const rest = match ? value.slice(match.length) : value;
  return {
    countryCode: match ?? DEFAULT_COUNTRY_CODE,
    number: rest.replace(/\D/g, ""),
  };
}

export function formatPhone(
  raw: string | null | undefined,
  storedCode?: string | null,
): string {
  const { countryCode, number } = splitPhone(raw, storedCode);
  return number ? `${countryCode} ${number}` : "";
}
